import Select from 'components/Formik/Select';

const Role = ({ initialValues, data }) => {
	initialValues.Primary_Role__c = '';
	const { label, placeholder, options } = data;
	return (
		<Select label={label} name='Primary_Role__c' placeholder={placeholder} options={options} />
	);
};

export default Role;
